export * from './brandsCarousel.component'
